import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import SecondaryNavBar from 'Components/SecondaryNavBar/SecondaryNavBar';
import LoadingOverlay from "../../../Components/LoadingOverlay/LoadingOverlay";
import { useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import { getDemandeAcit } from "../../../api/demandeAcitService";
import moment from "moment";
import { getObjectWithList } from "../../../utils/formUtils";
import PaginationWithTable from "../../../Components/PaginationWithTable/PaginationWithTable";
import { getTypeLabel } from "../../../utils/stringUtils";

export default function ListeDemande() {

    const navigate = useNavigate();

    const {
        detailPersonne,
        demandeAcit,
        contrat,
        contratsBeneficiaires,
        infosComplementaires,
        keycloakReduce,
    } = useSelector(state => ({
        ...state.gestionContratReducer,
        ...state.keycloakReducer,
    }))

    const CONF = window?.confPub
    const ROUTES = CONF?.ROUTES
    const UI_ACIT = CONF?.UI?.ACIT
    const PATTERNS = CONF?.PATTERNS
    const FORMULAIRE_ACIT = UI_ACIT?.FORMULAIRE
    const REFERENCES_ACIT = UI_ACIT?.REFERENCES
    const STATUT_DOSSIER = UI_ACIT?.REFERENCES?.STATUT_DOSSIER
    const TYPE_INDEMNITE = REFERENCES_ACIT?.TYPE_INDEMNITE
    const FAMILLE_MAINTIEN_SALAIRE = "MS"
    const FAMILLE_PREF_ACTIFS = "ID"

    const natureMaladieOptions = getObjectWithList(UI_ACIT?.FORMULAIRE?.NATURE_MALADIE?.OPTIONS, "VALUE")

    const [disabledForm, setDisabledForm] =useState(false)
    const [demandeAcitList, setDemandeAcitList] =useState([])

    useEffect(() => {

        const fetchGetDemandeAcit = async () => {
            try {

                // const resultDemandeAcit = await getDemandeAcit(keycloakReduce?.decodedToken?.idGrm ,detailPersonne?.idPersGrc)
                const resultDemandeAcit = await getDemandeAcit(keycloakReduce?.decodedToken?.idGrm, demandeAcit?.idPersGrc)

                console.log("resultDemandeAcit", resultDemandeAcit)

                // resultDemandeAcit?.forEach(demande => {
                //     console.log("JSON.parse(demande?.formulaire)")
                //     console.log(JSON.parse(demande?.formulaire))
                // })

                const sortedDemande = resultDemandeAcit.sort((a, b) => {

                    return moment(b.createdOn).diff(moment(a.createdOn));
                });

                const newList = sortedDemande.map(demande => {
                    return {
                        ...demande,
                        formulaire: JSON.parse(demande?.formulaire)
                    };
                });

                setDemandeAcitList(newList)

            } catch (err) {

            } finally {
                // setDisablePage(false);
            }
        }

        fetchGetDemandeAcit()

    }, [])

    const getLabelOuverture = (code) => {

        switch (code) {
        case STATUT_DOSSIER?.COMPLEMENT?.VALUE:
            return STATUT_DOSSIER?.COMPLEMENT?.LABEL
        case STATUT_DOSSIER?.OUVERTURE?.VALUE:
            return STATUT_DOSSIER?.OUVERTURE?.LABEL
        case STATUT_DOSSIER?.SUITE?.VALUE:
            return STATUT_DOSSIER?.SUITE?.LABEL
        default:
            return code
        }
    }

    const TableauAcit = ({ data:acitList }) => {

        if (acitList?.length > 0) {
            return (
                <div className='table-responsive-lg'>
                    <table className="table">
                        <thead>
                        <tr>
                            <th className="text-center">Date</th>
                            <th className="text-center">Nature maladie</th>
                            <th className="text-center">Statut</th>
                            <th className="text-center">Type</th>
                            <th className="text-center">Action</th>
                        </tr>
                        </thead>

                        <tbody>
                        { acitList?.length > 0 && acitList.map(demande => (
                            <tr key={ uuidv4() }>
                                <td className="text-center">{ moment(demande?.createdOn).format(CONF?.PATTERNS?.DD_SLASH_MM_SLASH_YYYY) }</td>
                                <td className="text-center">{ natureMaladieOptions?.[demande?.formulaire?.natureMaladie]?.LABEL }</td>
                                <td className="text-center">{ getLabelOuverture(demande?.formulaire?.ouverture) }</td>
                                {/*TODO concat contrats*/ }
                                <td className="text-center">{ demande?.formulaire?.type }</td>
                                <td className="text-center">
                                    <button
                                        className="btn btn-primary btn-sm"
                                        type="button"
                                        onClick={ () => navigate(ROUTES?.PAGES?.DEMANDE_INDEMNISATION?.FORMULAIRE_INDEMNISATION,
                                            { state: { isSuite: true, dossier: demande } }) }
                                    >
                                        Suite dossier
                                    </button>
                                    <button
                                        className="btn btn-secondary btn-sm ms-2"
                                        type="button"
                                        onClick={ () => navigate(ROUTES?.PAGES?.DEMANDE_INDEMNISATION?.FORMULAIRE_INDEMNISATION,
                                            { state: { isComplement: true, dossier: demande } }) }
                                    >
                                        Complément dossier
                                    </button>
                                </td>
                            </tr>
                        )) }

                        </tbody>
                    </table>
                </div>
            )
        } else {
            return (
                <div>Aucun dossier</div>
            )
        }
    }

    return (
        <div className="container demande-indemnisation-container mt-3">

            <SecondaryNavBar activePage='indemnisation'/>

            <main id='content' className='overlay-container'>

                { disabledForm && <LoadingOverlay classes="upload-overlay"/> }

                <div className="card">
                    <div className="card-header">
                        <h1 className="my-2">Demande d'indémnisation</h1>
                        <h2>{ detailPersonne?.civilite } { detailPersonne?.prenom } { detailPersonne?.nom } - né(e) le
                            : { detailPersonne?.dateNaissance } - { getTypeLabel(demandeAcit?.typeIndividu) }</h2>
                    </div>

                    <div className="card-body">
                        <PaginationWithTable
                            records={ demandeAcitList }
                            recordsPerPage={ 10 }
                            TableComponent={ TableauAcit }
                        />
                    </div>

                    <div className="card-footer">
                        <div className='d-flex justify-content-end'>
                            <button
                                className="btn btn-primary"
                                type="button"
                                onClick={ () => navigate(ROUTES?.PAGES?.DEMANDE_INDEMNISATION?.FORMULAIRE_INDEMNISATION) }
                            >
                                Demande de dossier
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    )
}